import { useCallback, useEffect, useState } from "react";
import { PppoeUserService } from "../services/PppoeUserService";
import { BankAccountService } from "../services/BankAccountService";

export const useHookBankAccount = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [params, setParams] = useState({
    });

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await BankAccountService.get({ params: params });
            setData(res?.data?.data);
            setMeta(res?.data?.meta);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,

        params,
        setParams,
        
        refreshData: getData,
    };
};